import { Toast } from "@ui-components/components";
import { useAppSelector } from "@potoo-modules/functions";

const ToastBox = () => {
  const isToastShown = useAppSelector((state) => state.toast.isShown);
  const toast_type = useAppSelector((state) => state.toast.toast_type);
  const toast_text = useAppSelector((state) => state.toast.toast_text);
  const btn_label = useAppSelector((state) => state.toast.btn_label);
  const onBtnClick = useAppSelector((state) => state.toast.onBtnClick);
  return (
    <div>
      {isToastShown && (
        <Toast
          type={toast_type}
          toast_text={toast_text}
          btn_label={btn_label}
          onBtnClick={onBtnClick}
          isShown={isToastShown}
        />
      )}
    </div>
  );
};

export { ToastBox };
